import config from "./config.js";
import mount from "./mount.js";

export { config, mount };
export default { config, mount };
